<a *ngIf="item" [routerLink]="detailViewUrl">
<div [class]="gridItemClass" [title]="item.title">

  <div [class]="imageContainerClass">

    <img [alt]="item.title" *ngIf="showPlaceHolder" [class]="imageClass + ' placeholder-img'" [class.hidden]="highResImageLoaded == true"
    src="./assets/images/item_placeholder.png">

    <div class="placeholder-text" *ngIf="showPlaceHolder">{{item.title}}</div>

    <img [alt]="" *ngIf="(!useIvan() || !storeIsItunes() || highResImageLoaded == false) && showPlaceHolder == false  && getHttpsImageUrl() != ''" [class.hidden]="highResImageLoaded == true"
    [class]="imageClass"
    [src]="getHttpsImageUrl()"
    (error)="showPlaceHolder = true">

    <img alt="" *ngIf="useIvan() && storeIsItunes()" [class.hidden]="highResImageLoaded == false"
    [class]="imageClass"
    [src]="getItemImageUrl()"
    (load)="highResImageLoaded = true" (error)="highResImageLoaded = false">

    <app-small-flags class="flags-container" [flags]="item.flags"></app-small-flags>
    <app-rank *ngIf="item.rank" class="rank-container" [rank]="item.rank" [rankDropIndicator]="item.rankDropIndicator"></app-rank>

    <div class="type-label" *ngIf="item.isBundle || item.isMovieBundle || item.isSeasonBundle">{{getString('bundle')}}</div>

    <ng-container *ngIf="inWishlist">
      <div class="wishlist-indicator"></div>
      <img alt="" class="wishlist-star-indicator" [title]="getString('removeFromWishlist')" src="./assets/images/star_filled_blue.png" (click)="removeFromWishlist($event)">
    </ng-container>

    <!-- Blocked badge oben links -->
    <div class="blocked-badge" *ngIf="inBlocklist">
      <span class="material-icons blocked-icon">block</span><span>{{getString('blocked')}}</span>
    </div>

    <div class="close-circle" (click)="removeFromOwnlist($event)">
      <span class="close-x">&#x2715;</span>
    </div>

    <div *ngIf="item.ownlistInfo && item.ownlistInfo.isMarkedAsRentalItem" class="rental-indicator">{{getString('toRent')}}</div>

  </div>

  <div [class]="footerClass">
    <div class="grid-item-footer-top txt-algn-cntr">
      <app-ratings *ngIf="item.imdbRating || item.tomatoesScore" [imdbId]="item.imdbId" [imdbRating]="item.imdbRating"
      [tomatoesRating]="item.tomatoesScore" [metacriticRating]="item.metacritic"></app-ratings>
      <div *ngIf="item.itemType != 'movie'" class="artist-title">
        <span *ngIf="item.itemType != 'season' && item.itemType != 'app' && item.itemType != 'macapp'">{{item.artist}}
          <span *ngIf="item.artist && item.title">-</span>
        </span>
         {{item.title}}
         <app-rating *ngIf="item.userRating" [rating]="item.userRating"></app-rating>
      </div>

      <div *ngIf="item.itemType == 'movie' && item.saveOpportunity" class="save-opportunity">
          {{getString('save')}} <span class="color-green">{{formatPrice(item.saveOpportunity, item.currency)}}</span> {{getString('withThisBundle')}}
      </div>

    </div>
    <div>
      <div class="float-left">
        <img alt="" *ngIf="item.has4K == 1 && !urlIsHomePage()" class="quality-icon" src="./assets/images/4k-icon.png">
        <img alt="" *ngIf="item.iTunesExtra && !urlIsHomePage()" class="itunes-extras-icon" src="./assets/images/itunes_extras.png">
        <img alt="" *ngIf="item.moviesAnywhere && !urlIsHomePage()" class="itunes-extras-icon" src="./assets/images/m_anywhere.png">
      </div>
    </div>
    <div class="added-at">
      {{getAddedFor()}}
    </div>
  </div>
</div>
</a>




